// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c412e09a","239":"9f05c4c2","455":"29221291","557":"dc33ce0c","904":"c4e3cb67"}[chunkId] + ".chunk.js";
};